import axios from "axios";
import axiosJsonpAdapter from "axios-jsonp";

export default class Main {
    constructor() {
        this.loaded = 0;
        this.loadLength = 16;
        this.currentCategory = this.getParam("category") || "";
        this.init();
    }

    init() {
        this.getData(this.currentCategory); //initial Get Data
        this.eventBind();
        this.setCallback();
        this.setNav();
    }

    getParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    eventBind() {
        const morebtn = document.querySelector(".js-discography_more");
        //const categorybtn = [...document.querySelectorAll(".js-discography_categorybtn")];

        morebtn.addEventListener("click", () => {
            this.getData(this.currentCategory);
        });

        // categorybtn.forEach((el) => {
        //     el.addEventListener("click", () => {
        //         const category = el.getAttribute("data-category");
        //         categorybtn.forEach((el) => el.classList.remove("-active"));
        //         el.classList.add("-active");
        //         this.sortList(category);
        //     });
        // });
    }

    setCallback() {
        const on_get_data = (data) => {
            this.loaded += data.items.length;
            this.setDom(data);

            //これ以上データがない場合はdisableに
            if (this.loaded >= data.total_count) {
                document.body.classList.add("-load_disable");
            }
        };

        //callbackはグローバル変数に
        window.on_get_data = on_get_data;
    }

    getData(category) {
        let API_URL = `https://www.sonymusic.co.jp/json/v2/artist/Flow/discography/start/${this.loaded}/count/${this.loadLength}/callback/on_get_data`;

        if (category && category !== "") {
            API_URL = `https://www.sonymusic.co.jp/json/v2/artist/Flow/discography/category/${category}/start/${this.loaded}/count/${this.loadLength}/callback/on_get_data`;
        }

        axios.get(API_URL, {
            adapter: axiosJsonpAdapter,
        });
    }

    setNav() {
        const listitem = [...document.querySelectorAll(".js-discography_categorybtn")];

        listitem.forEach((item) => {
            const item_category = item.getAttribute("data-category");
            if (item_category === this.currentCategory) {
                item.classList.add("-active");
            }
        });
    }

    sortList(category) {
        const listitem = [...document.querySelectorAll(".js-discography_item")];

        listitem.forEach((item) => {
            const item_category = item.getAttribute("data-category");
            item.classList.remove("-active");

            if (category === item_category || category === "all") {
                setTimeout(() => {
                    item.classList.add("-active");
                }, 100);
            }
        });

        //更新
        this.currentCategory = category;
    }

    setDom(data) {
        if (!data) {
            return;
        }

        let dom = "";
        const wrapper = document.querySelector(".js-discography_wrapper");

        const categoryMap = {
            シングル: "single",
            アルバム: "album",
            DVD: "bd/dvd",
            BD: "bd/dvd",
            配信限定: "streaming",
        };

        data.items.forEach((item) => {
            const category = categoryMap[item.type] || "";
            const isCurrentCategoryItem = category === this.currentCategory || this.currentCategory === "all";

            dom += `<li class="c-discography__list__item js-discography_item ${isCurrentCategoryItem ? "-active" : ""}" data-category="${category}">
            <a href="https://www.sonymusic.co.jp/artist/Flow/discography/${item.representative_goods_number}" target="_blank" class="c-imgzoombtn -noabs">
                <div class="thumb"><img src="${item.image_original}" alt=""/>
                </div>
                <h2 class="ttl">${item.title}</h2>
                <h3 class="info">${item.release_date}&nbsp;&nbsp;${item.price && "¥" + Math.floor(item.price).toLocaleString("ja-JP") + "（税込）"}</h3>
                <h4 class="category">#${category.toUpperCase()}</h4>
            </a>
        </li>`;
        });

        //MORE毎に追加する
        wrapper.insertAdjacentHTML("beforeend", dom);
    }
}
